import React from 'react';
import { AddDevice } from '../AddDevice';
import { EditTemplateEvaluations } from '../../Components/EditTemplateEvaluations';

const TemplateDeviceEvaluationModals = ({
    addDevice,
    fetchTemplate,
    setAddDevice,
    details,
    isEvalModalOpen,
    canEditTemplate,
    setIsEvalModalOpen,
    templateEvaluationData,
    setTemplateEvaluationData,
}) => (
    <>
        {addDevice ? (
            <AddDevice
                refresh={fetchTemplate}
                setState={setAddDevice}
                fixedTemplate={{
                    id: details?.id,
                    tid: details?.tid,
                    name: details?.name,
                    icon: details?.icon,
                }}
            />
        ) : null}
        {isEvalModalOpen && canEditTemplate && (
            <EditTemplateEvaluations
                state={isEvalModalOpen}
                setState={setIsEvalModalOpen}
                templateEvaluationData={templateEvaluationData}
                setTemplateEvaluationData={setTemplateEvaluationData}
            />
        )}
    </>
);

export default TemplateDeviceEvaluationModals;
